import { IContract, IContractPayment } from '@/interfaces/Contract';

export default class Contract implements IContract {
  id: number;
  origin: string;
  offer_name: string;
  price: number;
  estimated_renewal_starts_at: string;
  estimated_renewal_ends_at: string;

  current_cycle_payment_info: IContractPayment;

  constructor(contract: IContract) {
    Object.assign(this, { ...contract });
  }
}
